const DICEBEAR_API_URL = 'https://api.dicebear.com';

export const getDiceBearUserAvatar = (name, avatarId = 1) => {
  const baseUrl = `${DICEBEAR_API_URL}/9.x/personas/svg`;
  // Handle undefined/null name values safely
  const safeName = (name || 'user').trim();
  const safeAvatarId = avatarId || 1;
  const seed = encodeURIComponent(`${safeName}${safeAvatarId}`);
  
  const params = new URLSearchParams({
    seed,
    scale: 160,
    backgroundType: 'gradientLinear',
    translateX: 15,
    accessoriesProbability: 30,
    beardProbability: 40,
    glassesProbability: 30,
    hatProbability: 25,
    skinColor: 'ffffff,ffdbac,edb98a,d08b5b,ae5d29,8d4a43,5c3836,4a2c2a,3d2318,2d1810,1a0e0a,ff6b6b,ff8e53,ffb347,ff6347,ff4500,4a90e2,5dade2,48c9b0,52c3a3,7b68ee,9370db,8a2be2,9932cc,8b008b,4b0082',
    backgroundColor: '2d1810,3d2318,4a2c2a,5c3836,8d4a43,ae5d29,d08b5b,edb98a,8b0000,dc143c,ff4500,ff6347,ff8c00,ffa500,cd853f,d2691e,b8860b,daa520,8b4513,a0522d,ffff00,ffd700,daa520,ffeb3b,ffc107',
    clothingColor: '0e1621,3c4f5c,374151,2c3e50,34495e',
    hairColor: '090806,2c1810,8b4513,a0522d,cd853f',
    accessoriesColor: '000000,1a1a1a,2d2d2d,404040,525252',
    glassesColor: '000000,1a1a1a,2d2d2d,404040,525252',
    hatColor: '000000,1a1a1a,2d2d2d,404040,525252',
    beardColor: '090806,2c1810,8b4513,a0522d,cd853f'
  });
  
  return `${baseUrl}?${params.toString()}`;
};

export const getDiceBearGroupAvatar = (seed, options = {}) => {
  const baseUrl = `${DICEBEAR_API_URL}/9.x/initials/svg`;
  const params = new URLSearchParams({
    radius: 30,
    //backgroundColor: colors,
    backgroundType: 'solid,gradientLinear',
    backgroundRotation: '0,360',
    seed,
    ...options,
  });
  return `${baseUrl}?${params.toString()}`;
};